import { API_BASE_URL } from '../../utils/constants';

/** Read-only environment info. There is no server-side settings API yet. */
export default function SystemSettings() {
  const rows = [
    ['API base URL', API_BASE_URL],
    ['Build mode', process.env.NODE_ENV],
    ['Frontend host', typeof window !== 'undefined' ? window.location.host : '—'],
  ];
  return (
    <div className="page">
      <div className="container stack" style={{ maxWidth: 640 }}>
        <h1>System</h1>
        <div className="card pad stack">
          {rows.map(([k, v]) => (
            <div key={k} className="spread">
              <span className="muted">{k}</span>
              <code style={{ fontSize: '.85rem' }}>{v}</code>
            </div>
          ))}
        </div>
        <p className="muted" style={{ fontSize: '.88rem' }}>
          Category management lives under <a href="/admin/services">Trade categories</a>.
          Email delivery, JWT lifetime and DB connection are configured on the backend
          (environment variables / Secret Manager).
        </p>
      </div>
    </div>
  );
}
